export function currentMenu (state) {
  return state.currentMenu
}